<template>
  <div>
    <div
      v-if="def.actions || def.caption"
      class="d-flex justify-space-between align-center mb-4"
    >
      <p class="Panel-text px-1">
        {{ def.caption }}
      </p>
      <div class="d-flex align-center justify-center">
        <AppButton
          v-for="action in def.actions"
          :key="action.id"
          :def="action"
          :model="Model"
          text
        ></AppButton>
      </div>
    </div>
    <div v-if="!def.componentPath">
      <AppRow>
        <abr-form-prop
          v-for="prop in def.properties"
          :key="prop.id"
          class="px-2"
          :def="{ panel: def, ...prop }"
          :model="Model"
          :modal="modal"
        ></abr-form-prop>
      </AppRow>
      <AppRow v-if="def.grids">
        <AppColumn>
          <abr-grid
            v-for="grid in def.grids.filter((g, index) => gridsVisible[index])"
            :key="grid.id"
            :def="{ panel: def, ...grid }"
            :model="Model"
          ></abr-grid>
        </AppColumn>
      </AppRow>
    </div>
    <div v-else-if="def.componentPath">
      <component
        :is="component"
        :def="def"
        :model="Model"
      ></component>
    </div>
    <div
      v-if="def.panels"
      class="my-5"
    >
      <component
        :is="importPanel"
        v-for="panel in def.panels"
        :key="panel.id"
        :def="{...panel, parentPanel: def}"
        :form-model="Model"
        :model="prepareModel(panel)"
      ></component>
    </div>
  </div>
</template>

<script>
import AbrFormProp from "./AbrFormProp";
import AbrGrid from "../library/grids/AbrGrid";
import AppButton from "../library/action/AppButton";
import AppColumn from "../library/container/AppColumn";
import AppRow from "../library/container/AppRow";

export default {
  name: "AbrFormPanelWrapper",
  components: {
    AppButton,
    AppColumn,
    AppRow,
    AbrFormProp,
    AbrGrid
  },
  props: ["def", "model","modal"],
  data: function() {
    return {
      Model: this.model,
      gridsVisible: []
    }
  },
  computed: {
    component() {
      return () => this.def.componentPath && import("@/ext/" + this.def.componentPath);
    },
    importPanel() {
      return () => import("./AbrFormPanel");
    }
  },
  async created() {
    this.gridsVisible = await Promise.all(this.def.grids?.map(g => this.$checkVisibility(g)) || []);
    this.$eventBus.$on('changeModelInGrid' , (newModel , name) => {
        if(Array.isArray(this.Model) && this.def.relationPath === name){
          this.$set(this , "Model" , newModel)
        }else {
          this.$set(this.Model , name , newModel)
        }
    })
  },
  methods: {
    //TODO move to AbrRoot
    prepareModel(panel) {
      let e = this.Model;
       if(e==null) return;
      const path = panel.relationPath && panel.relationPath.split(".") || []

      for (let ix in path) {
        //TODO this is based on whether there are any properties on the panel. It should probably find the rel instead
        const p = path[ix]
        if (!(p in e))
          e[p] = ix < path.length - 1 || panel.grids && panel.grids.length ? [] : {}
        e = e[p]
      }

      return e
    },
  },
}
</script>